import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";
import { FC } from "react";

export const HearthIconSvg = () => (
  <svg
    width="25"
    height="22"
    viewBox="0 0 25 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5534 2.14244C10.2997 0.88283 8.59709 0.172633 6.81991 0.167992C5.04273 0.16335 3.33645 0.864646 2.07619 2.1177C0.823142 3.37795 0.121847 5.08424 0.126488 6.86141C0.131129 8.63859 0.841326 10.3412 2.10094 11.5949L11.8091 21.3051C12.0025 21.4985 12.2648 21.6071 12.5382 21.6071C12.8117 21.6071 13.0739 21.4985 13.2673 21.3051L22.926 11.6526C24.1784 10.3925 24.8793 8.68662 24.8747 6.90995C24.87 5.13328 24.1602 3.43112 22.9013 2.17751C22.28 1.55244 21.5416 1.05594 20.7284 0.716387C19.9151 0.37683 19.0429 0.200873 18.1616 0.198575C17.2803 0.196276 16.4072 0.367681 15.5922 0.702991C14.7772 1.0383 14.0362 1.53094 13.4117 2.15276L12.4898 3.07676L11.5534 2.14244ZM21.4637 10.1965L12.5413 19.1168L3.55913 10.1367C2.6868 9.26986 2.19421 8.09221 2.18957 6.86244C2.18493 5.63267 2.66862 4.45134 3.53438 3.57794C4.40731 2.71101 5.58878 2.22618 6.81905 2.23005C8.04933 2.23392 9.22773 2.72616 10.0952 3.59857L11.7658 5.2692C11.863 5.36635 11.9785 5.44312 12.1057 5.49499C12.233 5.54686 12.3693 5.57279 12.5066 5.57125C12.644 5.56971 12.7797 5.54074 12.9057 5.48604C13.0317 5.43133 13.1456 5.352 13.2405 5.2527L14.8699 3.61094C15.3029 3.18089 15.8163 2.84038 16.381 2.60886C16.9456 2.37734 17.5503 2.25936 18.1606 2.26166C18.7708 2.26396 19.3746 2.38649 19.9375 2.62226C20.5004 2.85802 21.0113 3.20239 21.441 3.63569C22.3137 4.50289 22.8063 5.68113 22.8106 6.91141C22.8148 8.14168 22.3304 9.3233 21.4637 10.1965Z"
      fill="currentColor"
    />
  </svg>
);

export const HearthIcon: FC<Partial<CustomIconComponentProps>> = (props) => (
  <Icon component={HearthIconSvg} {...props} />
);

export default HearthIcon;

HearthIcon.displayName = "HearthIcon";
